import AssignmentEditContainer from './container/AssignmentEditContainer'

export default AssignmentEditContainer
